<template>
    <div class="card rounded-more p-3" :style="style" ref="skeletonCard">
        <content-loader :viewBox="viewBox" :width="width" :height="height" preserveAspectRatio="none">
            <rect x="0" y="0" rx="3" ry="3" width="100" height="25" />
            <rect x="50%" y="55%" rx="3" ry="3" width="150" height="40" />
        </content-loader>
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
    name : 'SkeletonInfoCard',
    components : {
        ContentLoader
    },
    computed : {
        width : function(){
            if( this.$refs.skeletonCard ){
                return this.$refs.skeletonCard.getBoundingClientRect().width
            }
            
            return 320
        },
        height : function(){
            return 125
        },
        viewBox : function(){
            return `0 0 ${this.width} ${this.height}`
        },
        style: function(){
            return `height:${this.height}px`
        }
    }
}
</script>